import React from 'react';
import { VerificationCode } from '@/components';

interface VerificationCodeProps {
	formData: any;
	onNext: (data: { verificationCode: string }) => void;
	onProgress: (code: string[]) => void;
	verificationCodeStatusIsOk?: boolean | null;
	disabled?: boolean;
}

export const VerificationCodeStep: React.FC<VerificationCodeProps> = ({ formData, onNext, onProgress, verificationCodeStatusIsOk, disabled }) => {
	const handleSubmit = (verificationCode: string) => {
		onNext({ verificationCode });
	};

	return (
		<VerificationCode
			phone={formData.phone}
			onNext={handleSubmit}
			onProgress={onProgress}
			verificationCodeStatusIsOk={verificationCodeStatusIsOk as boolean}
			disabled={disabled}
		/>
	);
};
